<template>
  <div>
    <div class="pa-1 mt-2 bordered rounded bg-grey_3" v-if="list_options.list.length > 0">
      <v-sheet color="darkblue text-h6 pa-2">Les options: {{ total_inscrits }} inscrits au total</v-sheet>
      <div class="pa-1 my-2 bg-white bordered rounded" v-for="option in list_options.list" :key="option.id">
        <div class="text-body-1 font-weight-bold">
          {{ option.nom }} <span v-if="option.information_variante_tarif">- {{ option.information_variante_tarif
            }}</span>
        </div>
        <div v-if="option.get_metadata('nom_groupe_option')">
          <div class="text-body-2">
            Appartient au groupe
            <v-chip size="sm">
              {{ option.get_metadata("nom_groupe_option") }}
              <span class="ml-1" v-if="option.get_metadata('max_groupe_option')">(Max. {{
                option.get_metadata("max_groupe_option") }} inscrits)</span>
            </v-chip>
          </div>
        </div>
        <div class="d-flex sm-gap mb-2">
          <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0">{{ option.nb_inscrits
            }}<span v-if="option.quantite > 0" class="mr-1">/{{ option.quantite }}</span> inscrits</v-chip>
        </div>

        <v-progress-linear rounded :model-value="get_progress(option.nb_inscrits, option.quantite)" color="darkblue"
          height="6"></v-progress-linear>
      </div>
    </div>
    <div v-else>
      <v-sheet elevation="0" class="text-h6 pa-2">Ce module n'a pas d'option</v-sheet>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import List_Options from "@/classes/Options/List_Options.class";
export default {
  data() {
    return {
      list_options: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    total_inscrits() {
      let total = 0;
      for (let option of this.list_options.list) {
        total += parseInt(option.nb_inscrits);
      }
      return total;
    },
  },
  methods: {
    get_progress(nb, max) {
      if (max == 0) return 2;
      return (nb / max) * 100;
    },

    /* Charge la liste des courses */
    async get() {
      this.list_options = new List_Options(this.mainStore.module.id);
      await this.list_options.fetch();
    },
  },
  async created() {
    await this.get();
  },
};
</script>

<style lang="scss" scoped></style>